(function () {
  // Menu mobile
  document.querySelectorAll('[data-close-menu]').forEach(function (b) {
    b.addEventListener('click', function () { var d = b.closest('details'); if (d) d.removeAttribute('open'); });
  });
  document.querySelectorAll('.c-burger').forEach(function (d) {
    d.addEventListener('toggle', function () { document.body.style.overflow = d.open ? 'hidden' : ''; });
  });
  // Galerie produit : clic sur une miniature
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main]');
    gal.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-src');
        main.removeAttribute('srcset');
        main.alt = btn.getAttribute('data-alt') || '';
        gal.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
      });
    });
  });
  // Quantité + / -
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-step'), 10);
        var min = parseInt(input.getAttribute('min') || '1', 10);
        input.value = Math.max(min, v);
        if (input.form && input.form.hasAttribute('data-autosubmit')) { var u = document.createElement('input'); u.type = 'hidden'; u.name = 'update'; u.value = '1'; input.form.appendChild(u); input.form.submit(); }
      });
    });
  });
  document.querySelectorAll('form[data-autosubmit] input[name="updates[]"]').forEach(function (inp) {
    inp.addEventListener('change', function () { var u = document.createElement('input'); u.type = 'hidden'; u.name = 'update'; u.value = '1'; inp.form.appendChild(u); inp.form.submit(); });
  });
  // Variantes (si plusieurs)
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var price = document.querySelector('[data-price]');
      if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
      var url = new URL(window.location.href);
      url.searchParams.set('variant', sel.value);
      window.history.replaceState({}, '', url.toString());
    });
  });
  // Tri des collections
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Accueil : onglets « Du matin au soir »
  document.querySelectorAll('[data-hm-tabs]').forEach(function (box) {
    var tabs = box.querySelectorAll('[data-hm-tab]');
    var panels = box.querySelectorAll('[data-hm-panel]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-hm-tab');
        var bar = t.parentNode, top0 = bar.getBoundingClientRect().top;
        tabs.forEach(function (b) { b.setAttribute('aria-selected', b === t ? 'true' : 'false'); });
        panels.forEach(function (p) { if (p.getAttribute('data-hm-panel') === i) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); } });
        var d = bar.getBoundingClientRect().top - top0;
        if (d) { window.scrollBy(0, d); }
      });
    });
  });
})();

(function () {
  document.querySelectorAll('[data-bundle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var items = btn.getAttribute('data-ids').split(',').map(function (id) { return { id: Number(id), quantity: 1 }; });
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) { throw new Error('add'); } window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; });
    });
  });
})();

// Fluidité : questions et menus déroulants animés (sans clignotement)
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.hm-q, .c-acc details, .c-faq details').forEach(function (d) {
    var sum = d.querySelector('summary');
    var box = sum && sum.nextElementSibling;
    if (!box) { return; }
    sum.addEventListener('click', function (e) {
      e.preventDefault();
      if (reduce || !box.animate) { d.open = !d.open; return; }
      if (d._anim) { d._anim.cancel(); d._anim = null; box.style.overflow = ''; }
      var opening = !d.open;
      if (opening) { d.classList.remove('is-closing'); d.open = true; } else { d.classList.add('is-closing'); }
      var cs = getComputedStyle(box);
      var full = { height: box.getBoundingClientRect().height + 'px', opacity: 1, marginTop: cs.marginTop, paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom };
      var none = { height: '0px', opacity: 0, marginTop: '0px', paddingTop: '0px', paddingBottom: '0px' };
      box.style.overflow = 'hidden';
      var a = box.animate(opening ? [none, full] : [full, none], { duration: 260, easing: 'cubic-bezier(.4,0,.2,1)' });
      d._anim = a;
      a.onfinish = function () {
        if (!opening) { d.open = false; d.classList.remove('is-closing'); }
        box.style.overflow = '';
        d._anim = null;
      };
      a.oncancel = function () { box.style.overflow = ''; };
    });
  });
})();

// Retour en arrière : on retrouve la position des carrousels et la photo choisie
(function () {
  var K = 'calden_pos_' + location.pathname;
  var store;
  try { store = JSON.parse(sessionStorage.getItem(K) || '{}'); } catch (e) { store = {}; }
  function save() { try { sessionStorage.setItem(K, JSON.stringify(store)); } catch (e) {} }
  function isBack() {
    try { var n = performance.getEntriesByType('navigation')[0]; return !!n && n.type === 'back_forward'; } catch (e) { return false; }
  }
  var rails = Array.prototype.slice.call(document.querySelectorAll('.hm-rail'));
  var gals = Array.prototype.slice.call(document.querySelectorAll('[data-gallery]'));
  rails.forEach(function (r, i) {
    var t;
    r.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { store['r' + i] = r.scrollLeft; save(); }, 120);
    }, { passive: true });
    r.addEventListener('click', function () { store['r' + i] = r.scrollLeft; save(); }, true);
  });
  gals.forEach(function (g, i) {
    g.querySelectorAll('[data-thumb]').forEach(function (b, j) {
      b.addEventListener('click', function () { store['g' + i] = j; save(); });
    });
  });
  function restore() {
    rails.forEach(function (r, i) {
      var v = store['r' + i];
      if (typeof v === 'number' && Math.abs(r.scrollLeft - v) > 2) { r.scrollLeft = v; }
    });
    gals.forEach(function (g, i) {
      var j = store['g' + i];
      if (typeof j !== 'number') return;
      var b = g.querySelectorAll('[data-thumb]')[j];
      if (b && b.getAttribute('aria-pressed') !== 'true') b.click();
    });
  }
  if (isBack()) { restore(); window.addEventListener('load', restore); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) restore(); });
  // Nouvelle visite : on repart de zéro
  if (!isBack()) { store = {}; save(); }
})();

// Retour en arrière : on retrouve l'onglet « Le matin / La journée / Le soir »
(function () {
  var K = 'calden_tab_' + location.pathname;
  var boxes = Array.prototype.slice.call(document.querySelectorAll('[data-hm-tabs]'));
  var st;
  try { st = JSON.parse(sessionStorage.getItem(K) || '{}'); } catch (e) { st = {}; }
  function save() { try { sessionStorage.setItem(K, JSON.stringify(st)); } catch (e) {} }
  function isBack() {
    try { var n = performance.getEntriesByType('navigation')[0]; return !!n && n.type === 'back_forward'; } catch (e) { return false; }
  }
  function show(box, i) {
    box.querySelectorAll('[data-hm-tab]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-hm-tab') === i ? 'true' : 'false'); });
    box.querySelectorAll('[data-hm-panel]').forEach(function (p) { if (p.getAttribute('data-hm-panel') === i) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); } });
  }
  boxes.forEach(function (box, n) {
    box.querySelectorAll('[data-hm-tab]').forEach(function (t) {
      t.addEventListener('click', function () { st['t' + n] = t.getAttribute('data-hm-tab'); save(); });
    });
  });
  function restore() { boxes.forEach(function (box, n) { if (st['t' + n] != null) show(box, st['t' + n]); }); }
  if (isBack()) { restore(); } else { st = {}; save(); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) restore(); });
})();

// Retour en arrière : on rouvre le menu si on en était parti depuis le menu
(function () {
  var K = 'calden_menu_' + location.pathname;
  var d = document.querySelector('.c-burger');
  if (!d) return;
  function isBack() {
    try { var n = performance.getEntriesByType('navigation')[0]; return !!n && n.type === 'back_forward'; } catch (e) { return false; }
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (a && d.open) { try { sessionStorage.setItem(K, '1'); } catch (x) {} }
  }, true);
  var was = null;
  try { was = sessionStorage.getItem(K); sessionStorage.removeItem(K); } catch (e) {}
  if (was && isBack()) { d.open = true; }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { var w = null; try { w = sessionStorage.getItem(K); sessionStorage.removeItem(K); } catch (x) {} if (w) d.open = true; }
  });
})();

/* Date de livraison estimée : préparation 1–3 j ouvrés + livraison 7–10 j ouvrés = 8–13 j ouvrés */
(function () {
  var box = document.querySelector('[data-eta]');
  if (!box) return;
  var txt = box.querySelector('[data-eta-text]');
  var FIXED = ['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function isOff(d) {
    var w = d.getDay();
    if (w === 0 || w === 6) return true;
    return FIXED.indexOf(pad(d.getMonth() + 1) + '-' + pad(d.getDate())) > -1;
  }
  function addBiz(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) { d.setDate(d.getDate() + 1); if (!isOff(d)) n--; }
    return d;
  }
  function fmt(d) {
    try { return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }); }
    catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
  }
  var now = new Date();
  var a = addBiz(now, 8), b = addBiz(now, 13);
  var from = (a.getMonth() === b.getMonth()) ? String(a.getDate()) : fmt(a);
  txt.textContent = 'Livraison offerte et suivie · estimée du ' + from + ' au ' + fmt(b);
  box.hidden = false;
})();
